const utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/language-manager");

const recipesData = require("Data/recipes.json");
const recipesImages = require.context("Images/activity_page/recipes", false, /\.png$/);

module.exports = class RecipeCarousel
{
  constructor(options)
  {
    if(utils.isNull(options))
    {
      throw "options must be defined";
    }

    this.element = options.element;
    this.startAt = utils.isNotNull(options.startAt) ? options.startAt.replace(/#/g, "") : "recept_id_1";
    this.clickCallBack = options.clickCallBack;
    this.centered = utils.isNotNull(options.centered) && options.centered !== undefined ? options.centered : false;
    this.recipesData = recipesData.recipes;

    this.create();
  }

  create()
  {
    if(this._initialized !== true)
    {
      this.renderCarousel();

      this._initialized = true;
    }
  }

  getImageSource(id)
  {
    var requireKey = "./thumb_recipe" + id + ".png";

    if($.inArray(requireKey, recipesImages.keys()) !== -1)
    {
      return recipesImages(requireKey);
    }

    return null;
  }

  renderCarousel()
  {
    this.element.empty();

    this.element.append("<button id='carousel-slider-prev' class='slider-btn slider-btn-prev'></button>");
    this.element.append("<div id='recipes-carousel'></div>");
    this.element.append("<button id='carousel-slider-next' class='slider-btn slider-btn-next'></button>");

    var $carousel = $("#recipes-carousel");

    for(var i=0;i<this.recipesData.length;++i)
    {
      var f = this.recipesData[i];
      var fIndex = f.replace("recept_id_", "");

      var path = this.getImageSource(fIndex);

      var slide = $("<div class='recipe-slide'></div>");
      slide.append($("<img src='" + path + "' data-id='" + f + "' >"));
      slide.attr("data-recipe-id", f);
      slide.attr("data-recipe-index", fIndex);

      $carousel.append(slide);
    }

    $carousel.slick(
      {
        centerMode: false,
        focusOnSelect: false,
        mobileFirst: true,
        draggable: false,
        swipe: true,
        infinite: true,
        prevArrow: $("#carousel-slider-prev"),
        nextArrow: $("#carousel-slider-next"),
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive:[
          {
            breakpoint: 950,
            settings:
            {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 740,
            settings:
            {
              slidesToShow: 3 ,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 520,
            settings:
            {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 0,
            settings:
            {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

    var startSlideIndex = $(".slick-slider").find(".recipe-slide[data-recipe-id=" + this.startAt + "]").closest(".slick-slide").data("slick-index");

    if(startSlideIndex === null) startSlideIndex = 1;
    $carousel.slick("slickGoTo", startSlideIndex);

    if(this.clickCallBack !== undefined && utils.isFunction(this.clickCallBack))
    {
      $(".slick-slider").on("click", ".slick-slide", this.clickCallBack);
      //select the first (no 'afterChange')

      $(".slick-slider").find(".recipe-slide[data-recipe-id=" + this.startAt + "]").closest(".slick-slide").click();
    }

    this.setUpEventListeners();
  }

  setUpEventListeners()
  {

  }
};




// WEBPACK FOOTER //
// ./app/js/components/recipe-carousel.js